<script>
    import Button from "./Button.svelte"
    $: num = "";
</script>
<div class="container">
    <br>


<div><input class="input-num" bind:value={num} autofocus></div>
   
<br>
<Button bind:num/>
</div>	

<style>
    .input-num{
		background-color: #add8e6;
		width: 337px;
		margin: auto;
		text-align: right;
		border-radius: 1.5rem;
		padding: 10px;
		margin-bottom: 5px;
		height: 1.7cm;
		font-weight: bold;
		font-size: xx-large;
		word-wrap: break-word;
		inline-size: 337px;
		overflow-wrap: break-word;
		scroll-behavior: auto;
		overflow-x: scroll;
		  overflow-y: hidden;
	  white-space: nowrap;
	  caret-color: transparent;
	 
	 
	}
		
	#invisible {
		color: #add8e6;
	}
	
	.container {
		background-color: #00203fff;;
		width: 400px;
		text-align: center;
		border-radius: 1.5rem;
		box-shadow: #D3D3D3;
	}
</style>